module.exports = __webpack_public_path__ + "img/normal-login.497150f9.png";